// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import store from './store/index'
import router from './router'
import axios from './global/axios'
import auth from './global/auth'
import common from './global/common'
import config from './config/index'
import 'element-ui/lib/theme-chalk/index.css'
import directive from './directive/index'
// import '../theme/index.css' // 重置主题颜色
import ElementUI from 'element-ui'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import 'babel-polyfill'
import echarts from 'echarts' // 引入echarts
import App from './App'
import './common/css/scroll.css'
import './common/css/transition.css'
import './common/css/public.less'
import CourseSuspension from './components/Public/CourseSuspension.vue'
import MessageList from './components/Public/MessageList.vue'
import NoData from './components/Public/NoData.vue'

import VueQuillEditor from 'vue-quill-editor'
// require styles
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import imageResize from 'quill-image-resize-module' // 图片缩放组件引用
import { ImageExtend } from 'quill-image-extend-module'
import myQuill from './components/Public/Quill.vue'
// 配置图片预览插件
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import globalMethod from './global/method'
import {queryPlatformInfoByDomain, queryMenuList} from './api/public/auth'

Vue.component('myQuill', myQuill)
VueQuillEditor.Quill.register('modules/ImageExtend', ImageExtend) // 注册
VueQuillEditor.Quill.register('modules/imageResize', imageResize)
let Size = VueQuillEditor.Quill.import('attributors/style/size')
Size.whitelist = ['14px', '16px', '18px', '20px', '30px', '32px']
VueQuillEditor.Quill.register(Size, true)
Vue.use(VueQuillEditor)

// 公共方法 滚动到表单校验错误的位置
Vue.prototype.scrollToFormError = () => {
  setTimeout(() => {
    let element = document.querySelectorAll('.el-form-item__error')[0]
    element.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    })
  }, 50)
}

Vue.use(Viewer)
Viewer.setDefaults({
  // 需要配置的属性 注意属性并没有引号
  title: false,
  toolbar: true
})

// 注入所有共用方法
globalMethod(Vue)
// 课程卡片
Vue.component('CourseSuspension', CourseSuspension)
Vue.component('MessageList', MessageList)
Vue.component('NoData', NoData)
global.$sider = ''
Vue.config.productionTip = false
// 引用公共方法
Vue.prototype.$common = common
Vue.prototype.$echarts = echarts // 引入组件
// 引用axios插件
Vue.prototype.$http = axios
// 引用配置
Vue.prototype.$config = config
// 路由的判断
router.beforeEach(async (to, from, next) => {
  NProgress.start() // 开启Progress
  let token = common.getCookie('kf_access_token')
  try {
    // 获取平台信息
    if (Object.keys(store.state.Auth.platformInfo).length === 0) {
      let params = {
        subDomain: config.subDomain
      }
      const {data} = await queryPlatformInfoByDomain(params)
      if (data.resultCode === 0) {
        store.commit('setPlatformInfo', data.resultData)
      }
    }
    // 获取所有二级平台列表
    if (token && store.state.Auth.platformList.length === 0) {
      await store.dispatch('fetchGetPlatformList')
    }
    // 获取侧边菜单
    if (token && store.state.Auth.sider.length === 0) {
      const {data} = await queryMenuList()
      if (data.resultCode === 0) {
        store.dispatch('siderList', data.resultData)
      }
    }
  } catch (error) {
  }
  // 是否需要验证
  if (!to.matched.some(m => m.meta.auth)) {
    // 判断是否登录
    let userInfo = common.getUserInfo()
    store.state.Auth.sign = !!token
    store.state.Auth.token = token
    store.state.Auth.name = userInfo.nickName
    if (!to.matched.some(m => m.meta.auth)) {
      if (store.state.Auth.sign) {
        next()
      } else {
        if (to.name === 'Login') {
          next()
        } else {
          router.push({name: 'Login'})
        }
      }
    } else {
      next()
    }
  }
})
directive(Vue)
router.afterEach(() => {
  NProgress.done() // 结束Progress
})
/* eslint-disable no-new */
// 使用ElementUi
Vue.use(ElementUI)
new Vue({
  el: '#app',
  router,
  store,
  common,
  auth,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js